import BidTrashIcon from 'elements/BidTrashIcon/BidTrashIcon'
import React, { useState } from 'react'
import { ClipLoader } from 'react-spinners'
import useMounted from '@utilities/hooks/useMounted';
export const DeleteBidItem = ({
  handleDeleteItem,
  id,
  className = 'underline',
}: {
  handleDeleteItem: (id: string) => Promise<void>
  id: string
  className?: string
}) => {
  const mounted = useMounted()
  const [isDeleting, setIsDeleting] = useState(false)

  return (
    <div className={`w-4 ${className}`}>
      {isDeleting ? (
        <ClipLoader size={20} color={'#FF0000'} />
      ) : (
        <button
          type="button"
          onClick={async (e: any) => {
            e.stopPropagation()
            setIsDeleting(true)
            await handleDeleteItem(id)
            if (mounted) {
              setIsDeleting(false)
            }
          }}
        >
          <BidTrashIcon color="#FF0000" isLargeIcon />
        </button>
      )}
    </div>
  )
}
